(function () {
	function initBandSlider(el) {
		if (typeof Flickity === 'undefined') {
			console.error('band-slider: Flickity is not loaded');
			return;
		}

		if (el.bandFlickity) {
			el.bandFlickity.destroy();
		}

		el.bandFlickity = new Flickity(el, {
			cellAlign: 'left',
			contain: true,
			groupCells: true,
			pageDots: el.dataset.pageDots === 'true',
			prevNextButtons: el.dataset.navigation === 'true',
			wrapAround: false
		});
	}

	function initAll(scope) {
		(scope || document).querySelectorAll('[data-band-slider]').forEach(initBandSlider);
	}

	if (document.readyState !== 'loading') {
		initAll();
	} else {
		document.addEventListener('DOMContentLoaded', function () {
			initAll();
		});
	}

	// Theme editor support
	document.addEventListener('shopify:section:load', function (event) {
		initAll(event.target);
	});

	document.addEventListener('shopify:block:select', function (event) {
		var slider = event.target.closest('[data-band-slider]');
		if (slider && slider.bandFlickity) {
			var cell = event.target.closest('.band-slider__cell');
			var index = Array.prototype.indexOf.call(slider.querySelectorAll('.band-slider__cell'), cell);
			if (index > -1) {
				slider.bandFlickity.selectCell(index);
			}
		}
	});
})();
